import React from 'react';
import { StarIcon } from 'lucide-react';
import { SectionCTA } from '../SectionCTA';
import { testimonials } from '../../data/content';
export function Testimonials() {
  return <section className="w-full bg-cream px-4 py-14" data-id="element-212" data-mp="3mh2cbymv9mhp">
      <div className="mx-auto w-full max-w-3xl" data-id="element-213" data-mp="3mf7rslfibwe5">
        <h2 className="text-center font-display text-[26px] font-extrabold leading-tight text-ink sm:text-4xl" data-id="element-214" data-mp="3r7905w9k12yw">
          What Dentists Are Saying
        </h2>

        <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2" data-id="element-215" data-mp="3ahufi4mglo">
          {testimonials.map(testimonial => <figure key={testimonial.name} className="rounded-3xl border border-gold/20 bg-white p-5" data-id="element-216" data-mp="91w8yz1nz3y2">
              <div className="flex gap-0.5" aria-label="5 out of 5 stars" data-id="element-217" data-mp="dzxs1jz3b39j">
                {Array.from({
              length: 5
            }).map((_, index) => <StarIcon key={index} className="h-4 w-4 fill-gold text-gold" aria-hidden="true" data-id="element-218" data-mp="2avdarm345akw" data-mpi={index} />)}
              </div>
              <blockquote className="mt-3 text-[15px] leading-relaxed text-ink" data-id="element-219" data-mp="1ntt0b3cy14sd">
                “{testimonial.quote}”
              </blockquote>
              <figcaption className="mt-4 flex items-center gap-3 border-t border-sand pt-4" data-id="element-220" data-mp="1ivj1mis0fm20">
                <img src={testimonial.image} alt={`Photo of ${testimonial.name}`} className="h-11 w-11 rounded-full object-cover" loading="lazy" data-id="element-221" data-mp="1eu5yiggaxwys" />
                <div data-id="element-222" data-mp="26i7mndcbfumu">
                  <p className="text-[14px] font-bold text-ink" data-id="element-223" data-mp="22ip6svzcq9qv">{testimonial.name}</p>
                  <p className="text-[12px] text-ink-soft" data-id="element-224" data-mp="22kjs4bejc3vh">{testimonial.country}</p>
                </div>
              </figcaption>
            </figure>)}
        </div>

        <SectionCTA headline="Join the 1,200+ dentists already deciding with certainty." data-id="element-225" data-mp="r4v2fc9wcqqz" />
      </div>
    </section>;
}